import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector } from '@angular/core';
import { Subject } from 'rxjs';
import { PDFViewerModalComponent } from '../../components/modal/pdfviewer-modal/pdfviewer-modal.component';
import { ModalController } from '../modal-controller/modal-controller.service';

@Injectable({
  providedIn: 'root'
})
export class PDFViewerModalControllerService extends ModalController {

  constructor(    
    private componentFactoryResolverSingle: ComponentFactoryResolver,
    private applicationRefSingle: ApplicationRef,
    private injectorSingle: Injector ) 
    {
    super(componentFactoryResolverSingle, applicationRefSingle, injectorSingle);
  }

  createModal(sources: {title: string, url: string}[]) {
    const title = new Subject<string>();
    super.create({
      title,
      content: {
        component: PDFViewerModalComponent,
        props: {
          sources,
          title
        }
      }
    });
  }

  present() {
    return super.present();
  }

}
